import { Component, OnInit } from "@angular/core";
import { AuthService } from "src/app/_app-core/services/auth/auth.service";
import { Router } from "@angular/router";

@Component({
    selector: "app-exit-impersonation",
    templateUrl: "./exit-impersonation.component.html",
    styleUrls: ["./exit-impersonation.component.scss"],
})
export class ExitImpersonationComponent implements OnInit {
    constructor(private authService: AuthService, private router: Router) {}

    ngOnInit(): void {
        const userData = {
            session: { sessionId: localStorage.getItem("userSession") },
        };
        const session = localStorage.getItem("userSession");
        const adminName = localStorage.getItem("adminUser");
        const adminEmail = localStorage.getItem("adminEmail");
        this.authService.logOut(userData).subscribe(
            (res) => {
                this.clearLocalStorage();
                this.navigateToAdminPortal(session, adminName, adminEmail);
            },
            (error) => {
                this.clearLocalStorage();
                this.navigateToAdminPortal(session, adminName, adminEmail);
            }
        );
    }

    clearLocalStorage() {
        localStorage.removeItem("impersonation");
        localStorage.removeItem("userSession");
        localStorage.removeItem("adminUser");
        localStorage.removeItem("adminEmail");
    }

    navigateToAdminPortal(session, adminName, adminEmail) {
        setTimeout(() => {
            window.location.href =
            "https://admin.jswap.payex.live/#/return?token=" +
            session +
            "$$$" +
            adminName +
            "$$$" +
            adminEmail;
        }, 100);

    }
}
